import type {FlexSuiteOverviewPage} from '../../../lib/types/contentful'

export type OverviewTemplateProps = {
  page: FlexSuiteOverviewPage
}

export function OverviewTemplate({page}: OverviewTemplateProps) {
  const {template} = page.fields
  const title = template.fields.title
  return <div>Flex Suite - Overview Template: {title}</div>
}
